import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // make sure FA is loaded
import Logo from "../assets/RCS-Logo-White.png";

const Footer = () => {
  return (
    <footer className="relative bg-blue font-poppins overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 right-10 w-64 h-64 bg-yellow/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Company Info Section */}
          <div className="space-y-6">
            {/* Logo and Company Name */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/10 rounded-2xl">
                  <img
                    src={Logo}
                    alt="RCS Logistics Philippines"
                    className="h-10 w-auto filter brightness-110"
                  />
                </div>
                <div>
                  <h3 className="text-white font-bold text-xl">RCS LOGISTICS</h3>
                  <p className="text-white/70 text-sm">Philippines</p>
                </div>
              </div>

              <p className="text-white/80 leading-relaxed max-w-sm">
                RCS Logistics Philippines provides exceptional transport services
                with reliability, innovation, and commitment to excellence in every
                shipment.
              </p>
            </div>

            {/* Social Media Links */}
            <div className="space-y-3">
              <h4 className="text-yellow font-semibold text-sm uppercase tracking-wider">
                Follow Us
              </h4>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/rcsphil?mibextid=wwXIfr&rdid=csNSQth4vQbQ9LsF&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Bnt6YGWMY%2F%3Fmibextid%3DwwXIfr#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-12 h-12 bg-white/10 hover:bg-yellow rounded-2xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f text-white group-hover:text-blue text-lg transition-colors duration-300"></i>
                </a>
                <a
                  href="https://www.instagram.com/rcslogistics?igsh=a3V2NWg2dHgxeDdt"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-12 h-12 bg-white/10 hover:bg-yellow rounded-2xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram text-white group-hover:text-blue text-lg transition-colors duration-300"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Office Information */}
          <div className="space-y-6">
            <h4 className="text-yellow font-bold text-lg flex items-center gap-2">
              <div className="w-8 h-8 bg-yellow/20 rounded-xl flex items-center justify-center">
                <i className="fas fa-building text-yellow text-sm"></i>
              </div>
              Our Main Office
            </h4>

            <div className="space-y-4">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-blue/20 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="fas fa-map-marker-alt text-yellow text-sm"></i>
                  </div>
                  <div>
                    <h5 className="text-white font-semibold mb-1">Address</h5>
                    <p className="text-white/80 text-sm leading-relaxed">
                      Retail C, GF, BM ONE Building <br />
                      Amvel Business Park <br />
                      Ninoy Aquino Ave San Dionisio, Paranaque
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-blue/20 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="fas fa-clock text-yellow text-sm"></i>
                  </div>
                  <div>
                    <h5 className="text-white font-semibold mb-1">Hours</h5>
                    <p className="text-white/80 text-sm leading-relaxed">
                      Mon-Fri: 8:30 AM - 5:30 PM<br />
                      Sat: 8:30 AM - 12:30 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <h4 className="text-yellow font-bold text-lg flex items-center gap-2">
              <div className="w-8 h-8 bg-yellow/20 rounded-xl flex items-center justify-center">
                <i className="fas fa-phone text-yellow text-sm"></i>
              </div>
              Contact Us
            </h4>

            <div className="space-y-4">
              {/* Phone Numbers */}
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 bg-blue/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-phone text-yellow text-sm"></i>
                  </div>
                  <div>
                    <h5 className="text-white font-semibold mb-1">Phone</h5>
                    <a
                      href="tel:+6288250200"
                      className="text-white/80 hover:text-yellow text-sm transition-colors duration-300 block"
                    >
                      (02) 88250200
                    </a>
                    <a
                      href="tel:+639177096992"
                      className="text-white/80 hover:text-yellow text-sm transition-colors duration-300 block"
                    >
                      +63 917 709 6992
                    </a>
                  </div>
                </div>
              </div>

              {/* Email */}
              <a
                href="mailto:sales@rcsphil.com"
                className="group flex items-center gap-3 p-4 bg-white/5 hover:bg-white/10 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-yellow/30 transition-all duration-300 transform hover:scale-[1.02]"
              >
                <div className="w-10 h-10 bg-blue/20 group-hover:bg-yellow/20 rounded-xl flex items-center justify-center transition-colors duration-300">
                  <i className="fas fa-envelope text-yellow text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-semibold">Email</p>
                  <p className="text-white/80 text-sm group-hover:text-yellow transition-colors duration-300">
                    sales@rcsphil.com
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-white/80 text-sm">
                © 2026 RCS Logistics Philippines. All Rights Reserved | <a href="/privacy-policy" className="hover:text-yellow transition-colors duration-300">Privacy Policy</a>
              </p>
            </div>

            {/* Designed By */}
            <div className="text-center md:text-right">
              <p className="text-white/60 text-xs">Designed By:</p>
              <a
                href="https://divinesoftwaresystems.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 text-yellow hover:text-white font-semibold text-sm transition-colors duration-300"
              >
                <i className="fas fa-code text-xs group-hover:animate-pulse"></i>
                Divine Software Systems
                <i className="fas fa-external-link-alt text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
